module.exports = __webpack_public_path__ + "static/img/bg-id.a24b6813.png";